import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { StudentAnsweredAssignment } from '@ts-core/modules/assignments/types';

import {
  getStudentAnsweredAssignmentQuery,
  GetStudentAnsweredAssignmentQueryResult,
  GetStudentAnsweredAssignmentQueryVariables,
} from '../graphql/queries/getStudentAnsweredAssignmentQuery';

type AnsweredAssignmentHookResult = DataFetcherHookResult<StudentAnsweredAssignment, 'assignment'>;

interface ExercisesHookInput {
  courseId: string;
  studentId: string;
  assignmentId: string;
}

export default function useStudentAnsweredAssignment(input: ExercisesHookInput): AnsweredAssignmentHookResult {
  const { courseId, studentId, assignmentId } = input;
  const { data, loading, error } = useQuery<GetStudentAnsweredAssignmentQueryResult, GetStudentAnsweredAssignmentQueryVariables>(
    getStudentAnsweredAssignmentQuery,
    {
      variables: { courseId, studentId, assignmentId },
    }
  );

  return { loading, error: getErrorMessage({ error }), assignment: data?.assignment };
}
